import { render, staticRenderFns } from "./AdminsList.vue?vue&type=template&id=8da4a136&scoped=true&"
import script from "./AdminsList.vue?vue&type=script&lang=ts&"
export * from "./AdminsList.vue?vue&type=script&lang=ts&"
import style0 from "./AdminsList.vue?vue&type=style&index=0&id=8da4a136&lang=scss&scoped=true&"
import style1 from "./AdminsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da4a136",
  null
  
)

export default component.exports